import { render } from "./Comerciais.vue?vue&type=template&id=7cd2b202&scoped=true"
import script from "./Comerciais.vue?vue&type=script&lang=js"
export * from "./Comerciais.vue?vue&type=script&lang=js"

import "./Comerciais.vue?vue&type=style&index=0&id=7cd2b202&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd2b202"]])

export default __exports__